import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { RootState } from '../../../../store/root-reducer';
import {
  exploreDemoAccountRequest,
  getPollingNotificationsRequest,
  getUserNotificationsRequest,
  getUserSettingsRequest,
  getUserUnreadNotificationsRequest,
  markNotificationsAsReadRequest,
  updateHiddenNotificationRequest,
  updateLeadFinderVersionRequest,
} from '../../extra-actions';
import Header from './header';
import {
  disableBulkActionRequestPolling,
  enableBulkActionRequestPolling,
  clearFirebaseProgressNotification,
  resetExploreDemoAccountRequest,
  markNotificationAsRead,
  resetInitiateFetchUnreadCount,
  resetNotificationData,
  showGettingStartedVideoModal,
  startNotificationBlink,
  stopNotificationBlink,
  updateIsMultichannelActive,
  setDemoAccountEntryPoint,
  resetUpdateLeadFinderVersionRequest,
} from '../../home-slice';
import { SequenceIdRouteComponentProps } from '../../../sequence/types';
import { getMyProfileRequest } from '../../../settings/components/my-profile/extra-actions';
import {
  connectEmailAccountRequest,
  getSmtpImapAccountDetailsRequest,
  getEmailAccountsRequest,
  getEmailAccountRequest,
} from '../../../email-accounts/extra-actions';
import { EmailAccountsFilters } from '../../../email-accounts/types/email-account';
import { EmailAccountMethod } from '../../../email-accounts/enums/email-account';

import { UpdateAdminSettingsRequestPayload } from '../../../settings/types/request-payload';
import { updateAdminSettingsRequest } from '../../../settings/components/admin-settings/extra-actions';
import { resetUpdateAdminSettings } from '../../../settings/components/admin-settings/admin-settings-slice';
import {
  setAiColumnModalVisible,
  setIsAiColumnTemplateListCachedFromFilter,
} from '../../../prospect/prospect-slice';
import { setPageHeaderBannerAlert } from '../../../../shared/design-system/components/atoms/page-header/page-header-slice';

const mapStateToProps = (state: RootState) => ({
  notifications: state.home.notifications,
  pollingNotifications: state?.home?.pollingNotifications,
  pageHeaderBannerMessage: state.pageHeader.message,
  subscriptionDetails: state.home.subscription,
  ctaURL: state.pageHeader.CTAUrl,
  ctaText: state.pageHeader.CTAText,
  bannerTextTwo: state.pageHeader.bannerMessageTwo,
  paymentActionType: state.pageHeader.paymentActionType,
  target: state.pageHeader.target,
  bannerAlert: state.pageHeader.bannerAlert,
  bannerAlertType: state.pageHeader.bannerAlertType,
  ctaHandlerType: state.pageHeader.ctaHandlerType,
  ctaBtnText: state.pageHeader.ctaBtnText,
  notificationCount: state.home.notificationCount,
  userProfile: state?.myProfile?.myProfile,
  getUserNotificationsRequestStatus:
    state.home.markNotificationsAsReadRequest.status,
  agencyConfig: state.home.agencyConfig,
  getUserNotificationsDataRequestStatus:
    state.home.getUserNotificationsRequest.status,
  unreadNotificationCount: state.home.unreadNotificationCount,
  trackingId: state.home.trackingId,
  planName: state.home.subscription?.planName,
  planType: state.home?.subscription?.planType,
  planCode: state.home?.subscription?.planCode,
  remainingProspectLimit: parseInt(
    state.home.getPostLoadMetaResponse?.accountUsageQuotaRemaining?.[
      'PROSPECT.ADD'
    ],
    10,
  ),
  remainingEmailSentLimit: parseInt(
    state.home.getPostLoadMetaResponse?.accountUsageQuotaRemaining?.[
      'EMAIL.ADD'
    ],
    10,
  ),

  meta: state.home.meta,
  client: state.home.client,
  firstName: state.home.adminDetails?.firstName,
  getUserSettingsRequestStatus: state.home.getUserSettingsRequest.status,
  leadFinderCredits: (() => {
    const remaining =
      state?.home?.getPostLoadMetaResponse?.accountUsageQuotaRemaining;
    const leadReveal = remaining?.['LEAD.REVEAL'];
    const bucket2 = remaining?.['LEAD.REVEAL.BUCKET2'];
    const bucket2Val = bucket2 !== undefined ? parseFloat(bucket2) : 0;
    if (leadReveal !== undefined) {
      return parseFloat(leadReveal) + bucket2Val;
    }

    return parseFloat(remaining?.['LEAD.REVEAL.BUCKET1'] ?? '0') + bucket2Val;
  })(),

  getPostLoadMetaRequestStatus: state.home.getPostLoadMetaRequest.status,
  agencyConfigRequestStatus: state.home?.getAgencyConfigRequest.status,

  isMultichannelActive: state.home.isMultichannelActive,
  updateAdminSettingsRequestStatus:
    state.adminSettings.updateAdminSettingsRequest.status,
  updateAdminSettingsRequestError:
    state.adminSettings.updateAdminSettingsRequest.error,
  shouldBulkActionsPoll: state?.home?.shouldBulkActionsPoll || false,
  firebaseProgressNotifications:
    state?.home?.firebaseProgressNotifications || {},
  verified: state?.home?.verified || false,
  emailAccountSetupInProgress: state.emailAccount.emailAccountSetupInProgress,
  initiateFetchUnreadCount: state?.home?.initiateFetchUnreadCount || false,

  exploreDemoAccountRequestStatus: state.home.exploreDemoAccountRequest.status,
  exploreDemoAccountRequestError: state.home.exploreDemoAccountRequest.error,
  exploreDemoAccountRequestMessage:
    state.home.exploreDemoAccountRequest.message,

  isDemoAccount: state.home.isDemoAccount,
  demoAccountAccessToken: state.home.demoAccountAccessToken,
  demoAccountEntryPoint: state.home.demoAccountEntryPoint,
  role: state?.home?.role,
  leadFinder: state.home.leadFinder,
  updateLeadFinderVersionRequestStatus:
    state.home.updateLeadFinderVersionRequest.status,
});

const mapDispatchToProps = {
  sendGetUserNotificationRequest: (page: number) =>
    getUserNotificationsRequest(page),
  sendGetPollingNotificationsRequest: (cancelToken: any) =>
    getPollingNotificationsRequest(cancelToken),
  sendUpdateHiddenNotificationRequest: (notificationId: string) =>
    updateHiddenNotificationRequest(notificationId),
  sendMarkNotificationAsReadRequest: (notificationId?: string) =>
    markNotificationsAsReadRequest(notificationId),
  markNotificationAsRead: (notificationId?: string) =>
    markNotificationAsRead({ notificationId }),
  sendGetProfileRequest: () => getMyProfileRequest(),
  sendGetUserUnreadNotification: () => getUserUnreadNotificationsRequest(),
  showGettingStartedVideoModal: (show: boolean) =>
    showGettingStartedVideoModal({ show }),
  resetNotificationData: () => resetNotificationData(),
  sendConnectEmailAccountRequest: (
    method: EmailAccountMethod,
    emailAccountId?: number,
  ) => connectEmailAccountRequest({ method, emailAccountId }),
  sendGetSmtpImapAccountDetailsRequest: (emailAccountId: number) =>
    getSmtpImapAccountDetailsRequest(emailAccountId),
  sendGetEmailAccountsRequest: (filters: EmailAccountsFilters) =>
    getEmailAccountsRequest(filters),
  sendGetEmailAccountRequest: (id: string | number) =>
    getEmailAccountRequest(id),

  sendUpdateAdminDetailsRequest: (payload: UpdateAdminSettingsRequestPayload) =>
    updateAdminSettingsRequest(payload),
  resetUpdateAdminSettings: () => resetUpdateAdminSettings(),
  updateIsMultichannelActive: () => updateIsMultichannelActive(),
  enableBulkActionRequestPolling: () => enableBulkActionRequestPolling(),
  disableBulkActionRequestPolling: () => disableBulkActionRequestPolling(),
  clearFirebaseProgressNotification: (uuid: string) =>
    clearFirebaseProgressNotification(uuid),
  startNotificationBlink: () => startNotificationBlink(),
  stopNotificationBlink: () => stopNotificationBlink(),
  resetInitiateFetchUnreadCount: () => resetInitiateFetchUnreadCount(),

  sendGetUserSettingsRequest: () => getUserSettingsRequest(),

  sendExploreDemoAccountRequest: () => exploreDemoAccountRequest(),
  resetExploreDemoAccountRequest: () => resetExploreDemoAccountRequest(),
  setDemoAccountEntryPoint: (entryPoint: string) =>
    setDemoAccountEntryPoint(entryPoint),
  setAiColumnModalVisible: (visible: boolean) =>
    setAiColumnModalVisible(visible),
  setIsAiColumnTemplateListCachedFromFilter: (cached: boolean) =>
    setIsAiColumnTemplateListCachedFromFilter(cached),
  sendUpdateLeadFinderVersionRequest: (version: 'v1' | 'v2') =>
    updateLeadFinderVersionRequest(version),
  resetUpdateLeadFinderVersionRequest: () =>
    resetUpdateLeadFinderVersionRequest(),
  setPageHeaderBannerAlert: (payload: { bannerType: string }) =>
    setPageHeaderBannerAlert(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> &
  RouteComponentProps &
  SequenceIdRouteComponentProps;

export default withRouter(connector(Header));
